export type ReviewRecipient = "comment" | "inspector";
/** Only a leading explicit mention addresses Inspector; emails and quoted mentions stay comments. */
export function readInspectorMention(text: string): { mentioned: boolean; text: string } {
  const match = /^\s*@inspector(?=\s|$)[ \t]*\n?/i.exec(text);
  return match
    ? { mentioned: true, text: text.slice(match[0].length) }
    : { mentioned: false, text };
}
export function reviewCommentText(text: string, confirmedRequest = false) {
  const match = confirmedRequest ? /^@Inspector\r?\n/.exec(text) : null;
  return match
    ? { inspector: true, text: text.slice(match[0].length) }
    : { inspector: false, text };
}
export function reviewInitials(email: string | null) {
  return (
    email
      ?.split("@")[0]
      ?.split(/[._\s-]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((part) => part[0])
      .join("")
      .toUpperCase() || "?"
  );
}
/** "amir.isaac@x.test" → "Amir Isaac"; "ops+alerts@x.test" → "Ops": a name for someone known only by email. */
export function readableEmail(email: string): string {
  const local = email.split("@")[0]!.split("+")[0]!;
  const words = local.split(/[._-]+/).filter(Boolean);
  return words.length ? words.map((word) => word[0]!.toUpperCase() + word.slice(1)).join(" ") : email;
}
/** Who wrote a comment, by name as the organization knows them. */
export function commentAuthor(
  people: ReadonlyArray<{ userId: string; email: string; name: string | null }>,
  actorId: string | null | undefined,
  email: string | null,
): string {
  // By id first; an id the people list does not hold still matches by email.
  const person =
    (actorId ? people.find((candidate) => candidate.userId === actorId) : undefined) ??
    (email ? people.find((candidate) => candidate.email.toLowerCase() === email.toLowerCase()) : undefined);
  const known = person?.email ?? email;
  return person?.name?.trim() || (known ? readableEmail(known) : "Unknown author");
}
export const reviewMessageLimit = (recipient: ReviewRecipient) =>
  recipient === "inspector" ? 3900 : 4000;

export function sortReviewTimeline<T extends { id: string; createdAt: string; order?: number }>(
  entries: ReadonlyArray<T>,
): T[] {
  return [...entries].sort(
    (a, b) =>
      Date.parse(a.createdAt) - Date.parse(b.createdAt) ||
      (a.order ?? 0) - (b.order ?? 0) ||
      a.id.localeCompare(b.id),
  );
}
